module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', [_c('b', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/1cover#cover"
    }
  }, [_vm._v("MERIDIAN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/7chap1#chap1"
    }
  }, [_vm._v("Meridian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/8chap2#chap2"
    }
  }, [_vm._v("The Last Return")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/9chap3#chap3"
    }
  }, [_vm._v("The Wild Child")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/10chap4#chap4"
    }
  }, [_vm._v("Sojourner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/11chap5#chap5"
    }
  }, [_vm._v("“Have You Stolen Anything?”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/12chap6#chap6"
    }
  }, [_vm._v("Gold")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/13chap7#chap7"
    }
  }, [_vm._v("Indians and Ecstasy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/14chap8#chap8"
    }
  }, [_vm._v("English Walnuts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/15chap9#chap9"
    }
  }, [_vm._v("The Happy Mother")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/16chap10#chap10"
    }
  }, [_vm._v("Clouds")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/17chap11#chap11"
    }
  }, [_vm._v("The Attainment of Good")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/18chap12#chap12"
    }
  }, [_vm._v("Awakening")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/19chap13#chap13"
    }
  }, [_vm._v("Battle Fatigue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/20chap14#chap14"
    }
  }, [_vm._v("The Driven Snow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/21chap15#chap15"
    }
  }, [_vm._v("The Conquering Prince")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/22chap16#chap16"
    }
  }, [_vm._v("The Recurring Dream")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/23chap17#chap17"
    }
  }, [_vm._v("Truman Held")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/24chap18#chap18"
    }
  }, [_vm._v("Truman and Lynne: Time in the South")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/25chap19#chap19"
    }
  }, [_vm._v("Of Bitches and Wives")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/26chap20#chap20"
    }
  }, [_vm._v("The New York Times")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/27chap21#chap21"
    }
  }, [_vm._v("Visits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/28chap22#chap22"
    }
  }, [_vm._v("Lynne")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/29chap23#chap23"
    }
  }, [_vm._v("Tommy Odds")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/30chap24#chap24"
    }
  }, [_vm._v("Lynne")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/31chap25#chap25"
    }
  }, [_vm._v("On Giving Him Back to His Own")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/32chap26#chap26"
    }
  }, [_vm._v("Two Women")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/33chap27#chap27"
    }
  }, [_vm._v("Lynne")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/34chap28#chap28"
    }
  }, [_vm._v("Ending")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/35chap29#chap29"
    }
  }, [_vm._v("Free at Last")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/36chap30#chap30"
    }
  }, [_vm._v("Questions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/37chap31#chap31"
    }
  }, [_vm._v("Camara")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/38chap32#chap32"
    }
  }, [_vm._v("Travels")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/39chap33#chap33"
    }
  }, [_vm._v("Treasure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/40chap34#chap34"
    }
  }, [_vm._v("Pilgrimage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/41chap35#chap35"
    }
  }, [_vm._v("Atonement: Later, in the Same Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/42chap36#chap36"
    }
  }, [_vm._v("Settling Accounts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/43chap37#chap37"
    }
  }, [_vm._v("Release")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/1cover#cover"
    }
  }, [_vm._v("THE THIRD LIFE OF GRANGE COPELAND")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/6chap1#chap1"
    }
  }, [_vm._v("Part I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/7chap2#chap2"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/8chap3#chap3"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/9chap4#chap4"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/10chap5#chap5"
    }
  }, [_vm._v("Part II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/11chap6#chap6"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/12chap7#chap7"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/13chap8#chap8"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/14chap9#chap9"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/15chap10#chap10"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/16chap11#chap11"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/17chap12#chap12"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/18chap13#chap13"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/19chap14#chap14"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/20chap15#chap15"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/21chap16#chap16"
    }
  }, [_vm._v("Part III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/22chap17#chap17"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/23chap18#chap18"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/24chap19#chap19"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/25chap20#chap20"
    }
  }, [_vm._v("Part IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/26chap21#chap21"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/27chap22#chap22"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/28chap23#chap23"
    }
  }, [_vm._v("Part V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/29chap24#chap24"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/30chap25#chap25"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/31chap26#chap26"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/32chap27#chap27"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/33chap28#chap28"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/34chap29#chap29"
    }
  }, [_vm._v("24")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/35chap30#chap30"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/36chap31#chap31"
    }
  }, [_vm._v("Part VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/37chap32#chap32"
    }
  }, [_vm._v("26")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/38chap33#chap33"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/39chap34#chap34"
    }
  }, [_vm._v("28")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/40chap35#chap35"
    }
  }, [_vm._v("29")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/41chap36#chap36"
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/42chap37#chap37"
    }
  }, [_vm._v("Part VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/43chap38#chap38"
    }
  }, [_vm._v("31")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/44chap39#chap39"
    }
  }, [_vm._v("32")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/45chap40#chap40"
    }
  }, [_vm._v("33")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/46chap41#chap41"
    }
  }, [_vm._v("34")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/47chap42#chap42"
    }
  }, [_vm._v("35")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/48chap43#chap43"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/49chap44#chap44"
    }
  }, [_vm._v("37")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/50chap45#chap45"
    }
  }, [_vm._v("Part VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/51chap46#chap46"
    }
  }, [_vm._v("38")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/52chap47#chap47"
    }
  }, [_vm._v("39")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/53chap48#chap48"
    }
  }, [_vm._v("40")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/54chap49#chap49"
    }
  }, [_vm._v("Part IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/55chap50#chap50"
    }
  }, [_vm._v("41")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/56chap51#chap51"
    }
  }, [_vm._v("42")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/57chap52#chap52"
    }
  }, [_vm._v("43")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/58chap53#chap53"
    }
  }, [_vm._v("44")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/59chap54#chap54"
    }
  }, [_vm._v("Part X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/60chap55#chap55"
    }
  }, [_vm._v("45")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/61chap56#chap56"
    }
  }, [_vm._v("46")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/62chap57#chap57"
    }
  }, [_vm._v("Part XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/63chap58#chap58"
    }
  }, [_vm._v("47")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/64chap59#chap59"
    }
  }, [_vm._v("48")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Comon/36biography#biography"
    }
  }, [_vm._v("A Biography of Alice Walker")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77ad39dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bundle_content.vue
// module id = 66
// module chunks = 0